"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadingElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _cn = require("@udecode/cn");
var _plateCommon = require("@udecode/plate-common");
var _classVarianceAuthority = require("class-variance-authority");
var _jsxRuntime = require("react/jsx-runtime");
var headingVariants = (0, _classVarianceAuthority.cva)('', {
  variants: {
    isFirstBlock: {
      false: '',
      true: 'mt-0'
    },
    variant: {
      h1: 'mb-1 mt-[1em] font-heading text-4xl font-bold',
      h2: 'mb-px mt-[0.75em] font-heading text-2xl font-semibold tracking-tight',
      h3: 'mb-px mt-[0.50em] font-heading text-xl font-semibold tracking-tight',
      h4: 'mt-[0.25em] font-heading text-lg font-semibold tracking-tight',
      h5: 'mt-[0.25em] text-lg font-semibold tracking-tight',
      h6: 'mt-[0.25em] text-base font-semibold tracking-tight'
    }
  }
});
var HeadingElementVariants = (0, _cn.withVariants)(_plateCommon.PlateElement, headingVariants, ['isFirstBlock', 'variant']);
var HeadingElement = exports.HeadingElement = (0, _cn.withRef)(function (_ref, ref) {
  var children = _ref.children,
    isFirstBlock = _ref.isFirstBlock,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'h1' : _ref$variant,
    props = _objectWithoutProperties(_ref, ["children", "isFirstBlock", "variant"]);
  var editor = props.editor,
    element = props.element;
  var Element = variant;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(HeadingElementVariants, _objectSpread({
    asChild: true,
    isFirstBlock: element === editor.children[0],
    ref: ref,
    variant: variant
  }, props, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Element, {
      children: children
    })
  }));
});